<div class="w-100">
    <div class="page-info">
        <h3 style="margin: 25px; font-weight: 500; font-size:25px; color: #2a457a;">Financial Year</h3>
    </div>
</div>

<div class="table-container">
    <div class="table-mat-custom mat-elevation-z2">
        <table mat-table [dataSource]="dataSource" class="mat-table">
            <!-- Finyear Column -->
            <ng-container matColumnDef="finyear">
                <th mat-header-cell *matHeaderCellDef>Financial Year</th>
                <td mat-cell *matCellDef="let element">{{element.finyear}}</td>
            </ng-container>

            <!-- Status -->
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let element" class="actions-cell">
                    <button mat-icon-button *ngIf="element.status">
                        <mat-chip class="status-chip active-status">
                            <mat-label>Active FY</mat-label>
                        </mat-chip>
                    </button>
                    <button mat-icon-button *ngIf="element.status === false">
                        <mat-chip class="status-chip inactive-status">
                            <mat-label>Inactive FY</mat-label>
                        </mat-chip>
                    </button>
                </td>
            </ng-container>

            <!-- Actions -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>&nbsp;&nbsp;&nbsp;Actions</th>
                <td mat-cell *matCellDef="let element" class="actions-cell">
                    <button mat-icon-button (click)="lFN_ActivateFinancialYear(element);"
                        *ngIf="element.status === false">
                        <mat-icon title="Activate Financial Year"
                            style="-webkit-text-fill-color: #2a457a">present_to_all</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
    </div>
</div>